module.exports = __webpack_public_path__ + "static/media/Poppins-SemiBold-600.bafbc0b1.ttf";